export default __webpack_public_path__ + "static/media/guide19.caaaa1bf.png";